import { render, staticRenderFns } from "./boardView.vue?vue&type=template&id=4527d5c8&scoped=true&"
import script from "./boardView.vue?vue&type=script&lang=js&"
export * from "./boardView.vue?vue&type=script&lang=js&"
import style0 from "./boardView.vue?vue&type=style&index=0&id=4527d5c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4527d5c8",
  null
  
)

export default component.exports